import React from 'react'
import { FlagComponentReadOnly } from './FlagComponentReadOnly';
import moment from 'moment';
import BeschriftungAsSpan from './TeilnehmerMelden/BeschriftungAsSpan';

const PunktemeldungListItem = (props) => {
	const {punktemeldung, key, showTeilnahmedatum, vnr,
		className,
		showLernerfolg, istInEingabe, punkteBasis, punkteLernerfolg } = props
	const teilnahmedatum = punktemeldung.teilnahmedatum === null?null:moment(punktemeldung.teilnahmedatum).format('DD.MM.YYYY')
	let classNameAddOn = istInEingabe?"text-primary":""
	return(
		<li className={`${className} list-group-item`} key={key}>
			<div className={"row " + classNameAddOn}>
				<div className="col">{punktemeldung.efn}</div>
				{ showTeilnahmedatum && 
				<div className="col align-self-end text-end">{teilnahmedatum}</div>
				}
			</div>
			<div className="row">
				<div className="col"><BeschriftungAsSpan readOnly vnr={vnr} efn={punktemeldung.efn} /></div>
			</div>
			<div className="row text-secondary">
				<div className="col">
					<span className="badge bg-body-secondary text-body">Teilnahme ({punkteBasis} Pkt.) <FlagComponentReadOnly flag={punktemeldung.punkte_basis_flag} /></span>&nbsp;
					{showLernerfolg &&
						<>
						<span className="badge bg-body-secondary text-body">Lernerfolg ({punkteLernerfolg} Pkt.) <FlagComponentReadOnly flag={punktemeldung.punkte_lernerfolg_flag} /></span>
						&nbsp;
						</>
					}
					<span title="Kategorie (F) Punkte für Referent, Moderator, Wiss. Leitung" className="badge bg-body-secondary text-body">Ref/Mod/WL Pkte.: {punktemeldung.punkte_referent}</span>&nbsp;
					
				</div>
				<div className="col align-self-end text-end">
					<span className="badge" >{moment(punktemeldung.last_modified).format('DD.MM.YYYY HH:mm:ss')}</span>
				</div>
			</div>	
		</li>
	)
}

export default PunktemeldungListItem